const navConfig = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "About Us",
    path: "/about-us",
  },
  {
    title: "Our Services",
    path: "/our-services",
  },
  {
    title: "Our Projects",
    path: "/our-projects",
  },
  {
    title: "Blog",
    path: "/blog",
  },
  {
    title: "Contact Us",
    path: "/contact-us",
  },
];

export default navConfig;
